import compact from "lodash/compact";
import debounce from "lodash/debounce";
import map from "lodash/map";
import { INode } from "yfiles";
export default (graphReadyRef, onChangeModel, debounceWait) => debounce((sender, evt) => {
    var _a;
    if (!((_a = graphReadyRef.current) === null || _a === void 0 ? void 0 : _a.readyForListeners))
        return;
    if (evt.item instanceof INode) {
        const documentObjects = compact(map(sender.nodes.toArray(), "tag"));
        onChangeModel({ documentObjects, onlyDiffSources: false });
    }
}, debounceWait);
